import { createResourceAtom } from 'lib/atoms';
import type { OverviewResponse } from '../types-overview';
import { buildSectionMutationAtom } from 'lib/atoms/section-mutation';

// ---------------------------------------------------------------------------
// DO Overview section data layer. Mirror of
// `afe-catalog/structuring/atoms/identification.ts`:
//   • the section is one document-level singular resource, so the detail uses a
//     single `createResourceAtom` (auto-fetches on mount, setter refetches);
//   • edit + confirm/revert are uniform { url, method, data } mutation atoms
//     built from the SHARED `buildSectionMutationAtom` (from `lib/atoms` —
//     never recreated, so no DO payload keys land in api-payloads.ts).
//
// The confirm/revert href comes from `resources.confirmation.href` on the
// response (POST to Mark-as-Correct, DELETE to Remove-Correct-Status), exactly
// like AFE Identification.
// ---------------------------------------------------------------------------

export const createOverviewResourceAtom = (href: string | undefined) =>
  createResourceAtom<OverviewResponse>(href);

export const overviewUrl = (documentId: number | string) =>
  `/documents/${documentId}/division_order_structuring/overview`;

/** Edit overview fields (PATCH .../overview). Body { overview: {...snake_case...} }. */
export const editOverviewAtom = buildSectionMutationAtom<OverviewResponse>();

/** Mark overview as correct (POST resources.confirmation.href). */
export const confirmOverviewAtom = buildSectionMutationAtom<OverviewResponse>();

/** Remove correct status (DELETE resources.confirmation.href). */
export const revertOverviewAtom = buildSectionMutationAtom<OverviewResponse>();
